import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Route } from 'react-router-dom';
import { ApiKey } from '../../../../../../../typings/ApiKey.interface';
import LINKS from '../../../../configs/links';
import Button from '../../../common/base/Button';
import Container from '../../../common/base/Container';
import Divider from '../../../common/base/Divider';
import Icon from '../../../common/base/Icon';
import Link from '../../../common/base/Link';
import Tabs from '../../../common/base/Tabs';
import Text from '../../../common/base/Text';
import Tooltip from '../../../common/base/Tooltip';
import CopyableField from '../../../common/CopyableField';
import CodeSnippet from '../../../common/CodeSnippet';
import { Div } from '../../../common/helpers/StyledUtils';
import { useApiKeyActions } from '../../../hooks/useApiKeyActions';
import { AddTeamApiKeyModal } from '../../DashboardScene/Settings/Team/AddTeamApiKeyModal';
import { ProjectApiKeysTable } from '../../DashboardScene/Settings/Organization/OrganizationApiKeys/ProjectApiKeysTable';
import UpdateProjectApiKeyModal from '../../DashboardScene/Settings/Organization/OrganizationApiKeys/UpdateProjectApiKeyModal';
import { buildCreateDestinationExamples, buildCreateTenantExamples, buildPublishEventExamples, getOutpostInitExample, getOutpostInstallCommand, getOutpostSnippetLanguage, OUTPOST_BASE_URL, OUTPOST_EXAMPLE_TABS, OutpostExampleLanguage, useOutpostSnippetApiKey } from '../utils/outpostSnippets';
const DEMO_TENANT_ID = 'my-tenant-id';
const DEMO_TOPIC = 'order.created';
const DEMO_DESTINATION_URL = 'https://example.com/webhook';
const DEMO_EVENT_DATA = {
  order_id: 'ord_abc123',
  amount: 99.99
};
const TeamApiKey: React.FC = () => {
  const $ = _c(70);
  const [active_tab, setActiveTab] = useState("http");
  const [editing_api_key, setEditingApiKey] = useState(null);
  const {
    api_keys,
    mutate_api_keys,
    is_unauthorized,
    maskable_value
  } = useOutpostSnippetApiKey();
  let t0;
  if ($[0] !== mutate_api_keys) {
    t0 = {
      managed_from: "project",
      onRolled: () => mutate_api_keys(),
      onDeleted: id => mutate_api_keys(keys => keys?.filter(key => key.id !== id), false)
    };
    $[0] = mutate_api_keys;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    handleRollApiKey,
    handleDeleteApiKey
  } = useApiKeyActions(t0);
  let t1;
  if ($[2] !== active_tab) {
    t1 = getOutpostInstallCommand(active_tab);
    $[2] = active_tab;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== active_tab) {
    t2 = getOutpostInitExample(active_tab);
    $[4] = active_tab;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = {
      title: "Install and initialize the SDK",
      description: "Install the SDK package and initialize the client with your Outpost API key.",
      install_command: t1,
      example: t2
    };
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = buildCreateTenantExamples({
      tenant_id: DEMO_TENANT_ID
    });
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = t4[active_tab];
  let t6;
  if ($[10] !== t5) {
    t6 = {
      title: "Create a tenant",
      description: "Register a new tenant to receive webhook events.",
      install_command: null,
      example: t5
    };
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = buildCreateDestinationExamples(DEMO_TENANT_ID, {
      type: "webhook",
      topics: ["*"],
      config: {
        url: DEMO_DESTINATION_URL
      }
    });
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const t8 = t7[active_tab];
  let t9;
  if ($[13] !== t8) {
    t9 = {
      title: "Create a destination",
      description: "Add a webhook endpoint where the tenant will receive events.",
      install_command: null,
      example: t8
    };
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = buildPublishEventExamples({
      tenant_id: DEMO_TENANT_ID,
      topic: DEMO_TOPIC,
      data: DEMO_EVENT_DATA
    });
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = t10[active_tab];
  let t12;
  if ($[16] !== t11) {
    t12 = {
      title: "Publish an event",
      description: "Send an event to the tenant, which will be delivered to their destination.",
      install_command: null,
      example: t11
    };
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t3 || $[20] !== t6 || $[21] !== t9) {
    t13 = [t3, t6, t9, t12];
    $[18] = t12;
    $[19] = t3;
    $[20] = t6;
    $[21] = t9;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  const example_steps = t13;
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      b: 10
    };
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== mutate_api_keys) {
    t15 = <Route path="/settings/project/secrets/add" render={() => <AddTeamApiKeyModal onApiKeyCreated={api_key => {
      mutate_api_keys(keys_0 => [api_key, ...(keys_0 ?? [])], false);
    }} />} />;
    $[24] = mutate_api_keys;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== editing_api_key || $[27] !== mutate_api_keys) {
    t16 = editing_api_key && <UpdateProjectApiKeyModal api_key={editing_api_key} managed_from="project" onClose={() => setEditingApiKey(null)} onApiKeyUpdated={updated_api_key => {
      mutate_api_keys(keys_1 => keys_1?.map(key_0 => key_0.id === updated_api_key.id ? updated_api_key : key_0), false);
    }} />;
    $[26] = editing_api_key;
    $[27] = mutate_api_keys;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = {
      b: 10
    };
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  let t19;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = {
      b: 4
    };
    t19 = {
      justify: "space-between",
      align: "center"
    };
    $[30] = t18;
    $[31] = t19;
  } else {
    t18 = $[30];
    t19 = $[31];
  }
  let t20;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Text bold={true} size="l" as="h2" m={{
      y: 0
    }}>API Keys</Text>;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <Div>{t20}<Text muted={true}>Use your API Keys to authenticate requests to the{" "}<Link href={LINKS.outpost.api_ref} target="_blank">Outpost API</Link>.</Text></Div>;
    $[33] = t21;
  } else {
    t21 = $[33];
  }
  let t22;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <Div m={t18} flex={t19}>{t21}<Div><Button.Permission role="admin" unauthorized_tooltip="Only project admins can create API keys." to={_temp} primary={true} icon="add">Create API key</Button.Permission></Div></Div>;
    $[34] = t22;
  } else {
    t22 = $[34];
  }
  let t23;
  if ($[35] !== api_keys || $[36] !== handleDeleteApiKey || $[37] !== handleRollApiKey || $[38] !== is_unauthorized) {
    t23 = is_unauthorized ? <Tooltip fill={true} tooltip="As a viewer, you don't have permission to view or copy project API keys. Contact your project admin for further access." side="bottom"><CopyableField mono={true} disabled={true} value="***********************************************************************" /></Tooltip> : <ProjectApiKeysTable api_keys={api_keys} onEditKey={setEditingApiKey} onRollKey={handleRollApiKey} onDeleteKey={handleDeleteApiKey} />;
    $[35] = api_keys;
    $[36] = handleDeleteApiKey;
    $[37] = handleRollApiKey;
    $[38] = is_unauthorized;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Divider m={{
      y: 6
    }} />;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = {
      b: 4
    };
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <Div m={t25}><Text semi={true} muted={true} m={{
        b: 1
      }}>API Base URL</Text><CopyableField mono={true} value={OUTPOST_BASE_URL} /></Div>;
    $[42] = t26;
  } else {
    t26 = $[42];
  }
  let t27;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      align: "center",
      gap: 1
    };
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Link neutral={true} href={LINKS.outpost.api_ref} target="_blank"><Text semi={true} muted={true}>View full API reference</Text></Link>;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Div flex={t27}>{t28}<Text muted={true}><Icon icon="link" /></Text></Div>;
    $[45] = t29;
  } else {
    t29 = $[45];
  }
  let t30;
  if ($[46] !== t23) {
    t30 = <Div m={t17}>{t22}{t23}{t24}{t26}{t29}</Div>;
    $[46] = t23;
    $[47] = t30;
  } else {
    t30 = $[47];
  }
  let t31;
  if ($[48] !== t15 || $[49] !== t16 || $[50] !== t30) {
    t31 = <Container large={true} left={true} m={t14}>{t15}{t16}{t30}</Container>;
    $[48] = t15;
    $[49] = t16;
    $[50] = t30;
    $[51] = t31;
  } else {
    t31 = $[51];
  }
  let t32;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = {
      b: 10
    };
    $[52] = t32;
  } else {
    t32 = $[52];
  }
  let t33;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = {
      b: 10
    };
    $[53] = t33;
  } else {
    t33 = $[53];
  }
  let t34;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <Div m={{
      b: 4
    }}><Text bold={true} size="l" as="h2" m={0}>Example</Text><Text muted={true}>Publish events to your tenants using the API or one of the official SDKs.</Text></Div>;
    $[54] = t34;
  } else {
    t34 = $[54];
  }
  let t35;
  let t36;
  if ($[55] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = key_1 => setActiveTab(key_1 as OutpostExampleLanguage);
    t36 = {
      b: 4
    };
    $[55] = t35;
    $[56] = t36;
  } else {
    t35 = $[55];
    t36 = $[56];
  }
  let t37;
  if ($[57] !== active_tab) {
    t37 = <Tabs compact={true} tabs={OUTPOST_EXAMPLE_TABS} active_tab={active_tab} onTabSelected={t35} m={t36} />;
    $[57] = active_tab;
    $[58] = t37;
  } else {
    t37 = $[58];
  }
  let t38;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = {
      direction: "column",
      gap: 6
    };
    $[59] = t38;
  } else {
    t38 = $[59];
  }
  let t39;
  if ($[60] !== active_tab || $[61] !== example_steps || $[62] !== maskable_value) {
    t39 = <Div flex={t38}>{example_steps.map((step, index) => {
        const example = step.example;
        if (!example) {
          return null;
        }
        const step_number = active_tab === "http" ? index : index + 1;
        return <Div key={step.title}><Div flex={{
            align: "center",
            gap: 2
          }} m={{
            b: 1
          }}><Text semi={true}>{step_number}.</Text><Text semi={true}>{step.title}</Text></Div><Text muted={true} m={{
            b: 4
          }}>{step.description}</Text>{step.install_command && <CopyableField mono={true} value={step.install_command} m={{
            b: 4
          }} />}<CodeSnippet code={example} language={getOutpostSnippetLanguage(active_tab)} maskable_value={maskable_value} /></Div>;
      })}</Div>;
    $[60] = active_tab;
    $[61] = example_steps;
    $[62] = maskable_value;
    $[63] = t39;
  } else {
    t39 = $[63];
  }
  let t40;
  if ($[64] !== t37 || $[65] !== t39) {
    t40 = <Container large={true} left={true} m={t32}><Div m={t33}>{t34}{t37}{t39}</Div></Container>;
    $[64] = t37;
    $[65] = t39;
    $[66] = t40;
  } else {
    t40 = $[66];
  }
  let t41;
  if ($[67] !== t31 || $[68] !== t40) {
    t41 = <>{t31}{t40}</>;
    $[67] = t31;
    $[68] = t40;
    $[69] = t41;
  } else {
    t41 = $[69];
  }
  return t41;
};
export default TeamApiKey;
function _temp(loc) {
  return {
    ...loc,
    pathname: "/settings/project/secrets/add",
    state: {
      scroll: false
    }
  };
}